import { put, takeLatest } from "redux-saga/effects";
import { HttpService } from "src/services";

import { ArchiveListTypes } from "../types";
import { ReduxAction } from "../models";
import { Urls } from "src/constants";
import { AxiosResponse } from "axios";
import { ArchiveListAction } from "../actions";

export function* ArchiveListSaga() {
    yield takeLatest(ArchiveListTypes.REQUEST_LOAD_ARCHIVE_LIST, requestList);
}

function* requestList(action: ReduxAction) {

    try {
        const { count, type, offset, searchText, clear } = action.payload;
        const api = Urls.archive.list(count, type, offset, searchText);

        const response: AxiosResponse = yield HttpService.Fetch(api);

        let totalCount = response.headers["x-total-count"];
        totalCount = totalCount === null || totalCount === undefined ? -1 : totalCount;

        const list = response.data?.calendar || [];
        const promotions = response.data?.promotions;

        yield put(ArchiveListAction.setData(list, promotions, clear, count, totalCount));

    }
    catch {
        yield put(ArchiveListAction.hideLoading());
    }

}